import { render, staticRenderFns } from "./WebTipDialog.vue?vue&type=template&id=1f37dfcd&scoped=true"
import script from "./WebTipDialog.vue?vue&type=script&lang=js"
export * from "./WebTipDialog.vue?vue&type=script&lang=js"
import style0 from "./WebTipDialog.vue?vue&type=style&index=0&id=1f37dfcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f37dfcd",
  null
  
)

export default component.exports